<template>
  <div
    v-if="isMobile"
    class="lpu-services-filter-online px-3 d-flex justify-space-between align-center"
    @click="handleClick"
  >
    <v-icon
      color="primary"
    >
      ui-icon-calendar-date-and-clock
    </v-icon>
    <div class="text-body-2 text--text">
      Только услуги с онлайн-записью
    </div>
    <v-switch
      v-model="isEnabledOnline"
      inset
      @click.stop
      @change="handleChange"
    />
  </div>
  <v-switch
    v-else
    v-model="isEnabledOnline"
    class="mt-0"
    inset
    @change="handleChange"
  >
    <template #label>
      <span class="text-body-2 text--text">
        Только услуги с онлайн-записью
      </span>
    </template>
  </v-switch>
</template>

<script>
import { LPU_SERVICES_EVENTS } from 'www/vue_components/common/LpuServices/constants'

export default {
  name: 'LpuServicesOnlineSwitch',
  props: {
    isEnabledOnlineApp: {
      type: Boolean,
      default: false,
    },
  },
  data: vm => ({
    isEnabledOnline: vm.isEnabledOnlineApp,
    isMobile: window.MOBILE_VERSION,
  }),
  mounted() {
    window.addEventListener(LPU_SERVICES_EVENTS.switchOnline, () => {
      this.isEnabledOnline = false
      this.handleChange(this.isEnabledOnline)
    })
  },
  methods: {
    handleClick() {
      this.isEnabledOnline = !this.isEnabledOnline
      this.handleChange(this.isEnabledOnline)
    },
    handleChange(val) {
      this.$emit('lpu-services-online-switch:change', { val })
    },
  },
}
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.lpu-services {
  &-filter-online {
    width: 100%;
    height: 48px;
    border-radius: $border-radius-md;
    background-color: $ui-kit-bg-secondary;
  }
}
</style>
